module.exports = __webpack_public_path__ + "static/media/why_ru.30d03054.vtt";